import { Box, Card, CardContent, CardHeader, Typography } from "@mui/material";

import Error from "../common/Error";
import Loading from "../common/Loading";
import Avatar from "../common/Avatar";
import { useParams } from "react-router-dom";
import { useAppSelector, useContract, useUser } from "../../app/hooks";
import SupportCard from "../common/support/SupportCard";

export default function ContractComponent() {
  const params = useParams();

  const { contract, error, loading } = useContract(params.id);

  const userId = useAppSelector((state) => state.auth.userId);
  const { user } = useUser(userId);

  if (loading) return <Loading />;
  if (error) return <Error error={error} />;

  return (
    <>
      {contract !== null && (
        <>
          <Box sx={{ display: "flex", gap: 2 }}>
            <Avatar alt={contract.name} src={contract.avatar} />
            <Typography variant="h4">{contract.name}</Typography>
          </Box>

          <Card sx={{ width: "100%", maxWidth: "sm" }}>
            <CardHeader
              title={contract.short_desc}
              slotProps={{ title: "primary" }}
            />
            <CardContent>
              <Typography sx={{ wordWrap: "break-word" }}>
                {contract.long_desc}
              </Typography>

              <br />

              <Typography>
                <Typography component="span" color="text.secondary">
                  Partner:{" "}
                </Typography>
                {contract.partner}
              </Typography>

              <Typography>
                <Typography component="span" color="text.secondary">
                  Responsible:{" "}
                </Typography>
                {contract.owner}
              </Typography>

              <Typography>
                <Typography component="span" color="text.secondary">
                  Department:{" "}
                </Typography>
                {contract.department}
              </Typography>

              {contract.expiration_date !== undefined &&
                contract.expiration_date !== null && (
                  <Typography>
                    <Typography component="span" color="text.secondary">
                      Renewal:{" "}
                    </Typography>
                    {contract.expiration_date}
                  </Typography>
                )}

              <Typography sx={{ wordBreak: "break-word" }}>
                <Typography component="span" color="text.secondary">
                  Pricing:{" "}
                </Typography>
                {contract.pricing}
              </Typography>

              {(contract.tags || []).length > 0 && (
                <Typography>
                  <Typography component="span" color="text.secondary">
                    Tags:{" "}
                  </Typography>
                  {contract.tags?.join(", ")}
                </Typography>
              )}

              {contract.how_to_order && contract.how_to_order !== "" && (
                <>
                  <br />

                  <Typography>
                    <Typography component="span" color="text.secondary">
                      How to Order:{" "}
                    </Typography>
                    {contract.how_to_order}
                  </Typography>
                </>
              )}
            </CardContent>
          </Card>

          {user !== null && (
            <SupportCard
              resource={{
                kind: "Contract",
                inner: { id: contract.id.toString(), name: contract.name },
              }}
              user={user}
            />
          )}
        </>
      )}
    </>
  );
}
